import { http } from '../services';

class AvaliacaoService {
    avaliacaoForm() {
        return http.get('/avaliacao/form');
    }

    async getMediaAvaliador(projeto) {
        return http.get('/avaliacao', {
            projeto,
        });
    }

    async getNotasDiscrepantes(subevento, area) {
        return http.get('/notas-discrepantes', {
            subevento,
            area,
        });
    }

    async getProjetoFaltaAvaliar(subevento) {
        return http.get('/projetos-falta-avaliar', {
            subevento,
        });
    }

    async podeAvaliar(projeto) {
        return http.get('/pode-avaliar', {
            projeto,
        });
    }

    delete(projeto) {
        return http.delete('/avaliacao', {
            projeto,
        });
    }

    save(criterios, projeto) {
        return http.post('/avaliacao', {
            criterios,
            projeto,
        });
    }
}

const avaliacaoService = new AvaliacaoService();
export default avaliacaoService;
